// Loader: simple spinner
import React from "react";

export default function Loader({ label = "Chargement..." }) {
  return (
    <div className="flex items-center justify-center gap-3 p-6 text-slate-600 dark:text-slate-300">
      <div className="h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-slate-900 dark:border-slate-600 dark:border-t-slate-200" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
